<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.questions', 2),
                        href: meta.links.index,
                    },
                    {
                        name: question.title,
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="md:grid md:grid-cols-2 md:gap-6 mt-5">
            <div class="rounded-lg border-2 border-gray-300 py-2 px-3 shadow-lg flex flex-col justify-between">
                <div>
                    <div class="font-semibold text-gray-900 truncate">
                        {{ question.title }}
                    </div>
                    <div class="mt-3 p-2 bg-gray-100 rounded-lg" v-if="question.description">
                        <QuestionDescriptionDisplay :question="question" />
                    </div>
                    <div class="mt-3 p-2 bg-gray-100 rounded-lg" v-if="question.image_path">
                        <img :src="question.image_path" alt="cover" class="h-auto" />
                    </div>
                    <div class="mt-3 p-2 bg-gray-100 rounded-lg" v-if="question.shared_image">
                        <img :src="question.shared_image" alt="cover" class="h-auto" />
                    </div>
                    <div>
                        <CopyrightNotice :info="question.copyright" />
                    </div>

                    <HintAlert v-if="question.hint" class="mt-1">
                        <span class="font-semibold">{{ $t('messages.hint') }}:</span>
                        {{ question.hint }}
                    </HintAlert>

                    <component :is="question.type" :question="question" />
                </div>

                <div class="flex justify-between">
                    <div>
                        <div>{{ $t('messages.weight') }}: {{ question.weight }}</div>

                        <div>
                            <SmallNumberRangeIndicator :max="5" :value="question.difficulty" />
                        </div>
                        <div class="mt-1 flex flex-wrap space-x-2">
                            <BadgePill v-for="tag in question.tags" :key="tag">
                                {{ tag }}
                            </BadgePill>
                        </div>
                        <div>
                            <BadgePill color="gray">
                                {{ question.subject_name }}
                            </BadgePill>
                        </div>
                    </div>
                    <div class="flex flex-col justify-end">
                        <QuestionIcon class="text-gray-400 w-6 h-6" :type="question.type" />
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3" v-if="review">
            <component
                :is="question.type"
                :question="review"
                :students="[]"
                :with-percent="true"
                :is-teacher-mode="true"
            />
            <div class="mt-2 md:w-1/3">
                <ProgressBarCurrentMax :max="review.total_count" :current="review.answers_correct_count" />
            </div>
        </div>

        <div class="mt-5">
            <div>{{ $tc('messages.activities', 2) }}</div>
            <ul>
                <li v-for="activity in question.activities" :key="activity.id">
                    <InertiaSquareLinkButton action="show" :href="activity.links.show" /> {{ activity.title }}
                </li>
            </ul>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import QuestionEditFormPanel from '@/components/Quiz/QuestionEditFormPanel.vue';
import QuestionCreateFormPanel from '@/components/Quiz/QuestionCreateFormPanel.vue';
import HintAlert from '@/components/Quiz/HintAlert.vue';
import SmallNumberRangeIndicator from '@/components/SmallNumberRangeIndicator.vue';
import BadgePill from '@/components/BadgePill.vue';
import QuestionIcon from '@/components/QuestionIcon.vue';
import QuestionDescriptionDisplay from '@/components/Quiz/QuestionDescriptionDisplay.vue';
import CopyrightNotice from '@/components/CopyrightNotice.vue';
import QuestionGeneralReview from '@/components/Quiz/Review/QuestionGeneralReview.vue';
import QuestionShortAnswerReview from '@/components/Quiz/Review/QuestionShortAnswerReview.vue';
import QuestionOrderElementsReview from '@/components/Quiz/Review/QuestionOrderElementsReview.vue';
import ProgressBarCurrentMax from '@/components/Gamification/ProgressBarCurrentMax.vue';

export default {
    components: {
        ProgressBarCurrentMax,
        CopyrightNotice,
        QuestionDescriptionDisplay,
        QuestionIcon,
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
        QuestionEditFormPanel,
        QuestionCreateFormPanel,
        HintAlert,
        SmallNumberRangeIndicator,
        BadgePill,
        'multiple-choice': QuestionGeneralReview,
        'short-answer': QuestionShortAnswerReview,
        'true-false': QuestionGeneralReview,
        'order-phrase': QuestionGeneralReview,
        'order-elements': QuestionOrderElementsReview,
        'math-fraction': QuestionGeneralReview,
        'math-number-with-tolerance': QuestionGeneralReview,
        'multiple-answer': QuestionGeneralReview,
        'math-xyz-answers': QuestionGeneralReview,
        'math-multiple-magnitudes': QuestionGeneralReview,
        'math-prime-factors': QuestionGeneralReview,
        'math-polynomial-operation': QuestionGeneralReview,
        // { vue_question_review }
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'question', 'review'],
};
</script>
